import { ListagemPadrao } from "../../padronizado/listagem-padrao";
import { CodigoSistemaInterface } from "../../../types/CodigoSistemaInterface";
import { verificaSeAtivoERetornaBadge } from "../../../utils/verificaSeAtivoERetornaBadge/verificaSeAtivoERetornaBadge";
import { ColunaTabela } from "../../../components/Formularios/Table/CustomTable";
import { CampoPesquisa } from "../../../components/Modais/ModalFiltro";

// Definição das colunas da tabela
const colunas: ColunaTabela<CodigoSistemaInterface>[] = [
  { key: "tabela", label: "Tabela" },
  { key: "descricao", label: "Descrição" },
  {
    key: "situacao",
    label: "Situação",
    render: (situacao) => verificaSeAtivoERetornaBadge(String(situacao)),
    align: "center",
  },
];

// Campos exibidos no modal de pesquisa
const camposPesquisa: CampoPesquisa<CodigoSistemaInterface>[] = [
  { campo: "tabela", label: "Tabela", md: 4 },
  { campo: "descricao", label: "Descrição", md: 8 },
];

export const CodigiodoSistema: React.FC = () => {
  // Função para personalizar a mensagem de confirmação de exclusão
  const mensagemConfirmacaoExclusao = (codigo: CodigoSistemaInterface) => {
    return `Tem certeza que deseja excluir o código do sistema \n ${codigo.descricao}?`;
  };

  // Função para retornar o parâmetro de exclusão
  const getParametroExclusao = (codigo: CodigoSistemaInterface) => {
    return codigo.tabela;
  };

  return (
    <ListagemPadrao<CodigoSistemaInterface>
      titulo="Códigos do Sistema"
      tela="codigosistema"
      endpoint="/codigosistema"
      colunas={colunas}
      campoId="tabela"
      rotaBase="/cadastro/codigodosistema"
      camposPesquisa={camposPesquisa}
      usaPaginacaoServidor={false}
      mensagemConfirmacaoExclusao={mensagemConfirmacaoExclusao}
      parametroExclusao={getParametroExclusao}
    />
  );
};
